<div class="row">
  <div class="col-12">
    <ejs-grid #grid rowHeight="38" class="grid-with-toolbar grid-configuration" [dataSource]="data"
      [allowSorting]="true" [allowPaging]="true" [pageSettings]='pageSettings' [allowFiltering]="true"
      [filterSettings]="filterSettings" (rowSelected)="onRowSelected($event)">
      <e-columns>
        <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
        <e-column field="configurationName" headerText="{{'i18n.domain.import-configuration.name' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            {{data.configurationName}} - {{getTransferTypeName(data.transferType) | translate}} ({{data.id}})
          </ng-template>
        </e-column>
        <e-column field="importType" headerText="{{'i18n.domain.import-configuration.import-type' | translate}}"
          clipMode="EllipsisWithTooltip" [filter]="checkBoxFilter" [allowSorting]='false'>
          <ng-template #filterItemTemplate let-data>{{formatFilterImportType(data)}}</ng-template>
          <ng-template #template let-data>
            {{'i18n.domain.import-configuration.enums.import-type.' + ImportType[data.importType] | translate}}
          </ng-template>
        </e-column>
        <e-column [headerText]="'i18n.domain.import-configuration.edit.general.navision-template' | translate">
          <ng-template #template let-data>
            <div class="e-icons {{getNavisionTempalteIcon(data)}}"
              [title]="'i18n.domain.import-configuration.edit.general.navision-template' | translate"></div>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>